import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { UpdatePaymentApiTradesService } from "@/features/accounts/payment/api/services/update-trades-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { useAccountPollingContext } from "@/features/accounts/shared/contexts/account-polling-context";


export const useUpdatePaymentApiTrades = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  // ポーリング用コンテキスト
  const { addPollingInfo, removePollingInfo } = useAccountPollingContext();

  const updatePaymentApiTradesService = new UpdatePaymentApiTradesService();

  /*--------------------
    イベント関連
  --------------------*/

  // 明細更新
  const updatePaymentApiTrades = async (
    accountGroupId: string,
    paymentAccountId: string,
    paymentId: string,
    passbookType: string,
    scrapeType: number
  ) => {
    // API版明細更新はMoneyLinkサーバー⇆LookAPIの通信のためポーリング処理が存在しない．
    // ここで一意のIDを生成してポーリング情報に追加・削除することで
    // 処理中のローディング表示を実現させる
    const processId = `updatePaymentApiTrades-${paymentAccountId}-${paymentId}-${Date.now()}`;
    try {
      loadingCtx.setIsLoading(true);

      // ポーリング情報に追加
      addPollingInfo({
        processId,
        accountGroupId,
        mlinkAccountId: paymentAccountId,
        mlinkId: paymentId,
        passbookType,
        scrapeType: scrapeType,
      });

      await updatePaymentApiTradesService.updatePaymentApiTrades({
        account_group_id: accountGroupId,
        payment_account_id: paymentAccountId,
        payment_id: paymentId,
      });
    } catch (error) {
      // エラーハンドリング
      console.log("updatePaymentApiTrades:", error);
      // throw error;
    } finally {
      loadingCtx.setIsLoading(false);
      // ポーリング情報から削除
      removePollingInfo(processId);
    }
  };

  return {
    updatePaymentApiTrades: errorHandledAsync(updatePaymentApiTrades, setError),
  };
};
